/**
 * Switch tabs and their contents
 * @param {DOM node} tab the tab wanna switch to
 */
export const switchTab = (tab) => {
  // Set the new tab active
  const lastTabActive = document.querySelectorAll('[data-state="active"]')[0];
  lastTabActive.setAttribute('data-state', 'inactive');
  tab.setAttribute('data-state', 'active');

  // Switch the content
  const tabsWrapper = document.querySelector('.j-wrapper');
  tabsWrapper.classList.remove(`is-tab-active-${lastTabActive.id}`);
  tabsWrapper.classList.add(`is-tab-active-${tab.id}`);

  // Activate lazy elements
  document
    .querySelectorAll(`.j-lazy-onclick[data-template-block="template-block-${tab.id}"][data-src]:not([src])`)
    .forEach(($element) => {
      $element.src = $element.dataset.src;
    });
};
